<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
const props = defineProps({
  label: {
    default: '',
    type: String,
  },
  modelValue: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(["update:modelValue"])

const toggle = () => {
  emit("update:modelValue", !props.modelValue)
}
</script>
